import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { GroupattributesDialogComponent } from "../groupattributes-dialog/groupattributes-dialog.component";
import { ToastService } from "ng-uikit-pro-standard";
import { FormBuilder } from "@angular/forms";
import { AppConfig } from "src/app/config";
import { SectionDialogComponent } from "../section-dialog/section-dialog.component";

@Component({
  selector: "app-empty-section",
  templateUrl: "./empty-section.component.html",
  styleUrls: ["./empty-section.component.scss"],
})
export class EmptySectionComponent implements OnInit {
  @Output() translateSection: EventEmitter<string> = new EventEmitter<string>();

  translatingDialog(): void {
    this.translateSection.emit(this.sectionName);
  }

  @Input() section: any;
  @Input() field: any;
  @Input() groupfieldAttributes: any;
  @Input() groupFields: any;
  @Input() sectionId: string;
  sectionProperties: any;
  Groupfieldattributes: any;
  sectionName: string;
  detailPage: boolean;
  editPage: boolean;
  imageSection: boolean;
  systemSection: boolean;
  column: number;
  readonly: boolean;
  required: boolean;
  draggedIndex: number | null = null;
  hidden: boolean;
  islink: boolean;
  headerfields: boolean;
  hiddenonnew: boolean;
  hiddenonedit: boolean;
  linkfield: string;
  sequence: number;
  linkrelativeurl: string;
  object: string;
  recordtypeexist: string;
  lockedonedit: boolean;
  lockedonnew: boolean;
  // autofillsource:string;

  @Input() droppedDataFieldList: any[];
  @Output() droppedDataEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() sectionDeleted: EventEmitter<number> = new EventEmitter<number>();
  @Output() sectionPropertiesChanged: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() fieldPropertiesChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() groupFieldAttributesChanged: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() fieldDeletedEvent = new EventEmitter<any>();

  constructor(
    public dialog: MatDialog,
    private toastrService: ToastService,
    private fb: FormBuilder,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.sectionName = this.section.sectionName;
    this.detailPage = this.section.detailPage;
    this.editPage = this.section.editPage;
    this.imageSection = this.section.imageSection;
    this.systemSection = this.section.systemSection;
    this.column = this.section.column;
    // console.log(this.groupFields);
    // console.log(this.groupfieldAttributes);
    // console.log(this.section);
  }

  hiddenIndex: number = -1;

  delete(index: any) {
    console.log("Type Deleted", index);
    const field = this.droppedDataFieldList[index];
    this.fieldDeletedEvent.emit(field);
    this.droppedDataFieldList.splice(index, 1);
  }

  sectiondialog() {
    const dialogRef = this.dialog.open(SectionDialogComponent, {
      data: {
        sectionProperties: {
          sectionName: this.sectionName,
          detailPage: this.detailPage,
          editPage: this.editPage,
          onnew: this.section.onnew != null ? this.section.onnew : true,
          onedit: this.section.onedit != null ? this.section.onedit : true,
          imageSection: this.imageSection,
          systemSection: this.systemSection,
          column: this.column,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The section dialog was closed");
      if (result) {
        this.updateSectionProperties(result);
        console.log("updateSectionProperties", result);
      }
    });
  }
  updateSectionProperties(properties: any): void {
    this.sectionName = properties.sectionName;
    this.detailPage = properties.detailPage;
    this.editPage = properties.editPage;
    this.section.onnew = properties.onnew;
    this.section.onedit = properties.onedit;
    this.imageSection = properties.imageSection;
    this.systemSection = properties.systemSection;
    this.column = properties.column;
    this.sectionPropertiesChanged.emit(properties);
  }

  showDialog(fieldname: any) {
    console.log("fieldname", fieldname);

    const properties = this.groupFields[fieldname];
    console.log("properties", properties);
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        fieldname: fieldname,
        fieldProperties: {
          readonly: properties ? properties.readonly : false,
          required: properties ? properties.required : false,
        },
      },
    });

    dialogRef.afterClosed().subscribe((results) => {
      console.log("The dialog was closed");
      console.log("fieldname", fieldname);

      if (results) {
        this.updateFieldProperties(results, fieldname);
        console.log("updateFieldProperties", results);
      }
    });
  }

  groupattributes(fieldName: string) {
    const attributes = this.groupfieldAttributes[fieldName];

    const dialogRef = this.dialog.open(GroupattributesDialogComponent, {
      height: "560px",
      width: "500px",
      data: {
        fieldName: fieldName,
        Groupfieldattributes: {
          hidden: attributes ? attributes.hidden : false,
          islink: attributes ? attributes.islink : false,
          headerfields: attributes ? attributes.headerfields : false,
          hiddenonnew:
            attributes && attributes.hiddenonnew != null
              ? attributes.hiddenonnew
              : false,
          hiddenonedit:
            attributes && attributes.hiddenonedit != null
              ? attributes.hiddenonedit
              : false,
          onnew: attributes && attributes.onnew != null ? attributes.onnew : true,
          onedit: attributes && attributes.onedit != null ? attributes.onedit : true,
          sequence: attributes ? attributes.sequence : 0,
          linkfield: attributes ? attributes.linkfield : "",
          linkrelativeurl: attributes ? attributes.linkrelativeurl : "",
          object: attributes ? attributes.object : "",
          recordtypeexist: attributes ? attributes.recordtypeexist : false,
          lockedonedit: attributes ? attributes.lockedonedit : false,
          lockedonnew: attributes ? attributes.lockedonnew : false,
          // autofillsource: attributes ? attributes.autofillsource : "",
        },
      },
      panelClass: "custom-dialog-class", // Add custom panel class here
    });

    dialogRef.afterClosed().subscribe((results) => {
      console.log("The Attributes dialog was closed");
      console.log("fieldname", fieldName);

      if (results) {
        this.updateGroupAttributes(results, fieldName);
        console.log("Attributes Result", results, fieldName);
      }
    });
  }

  updateFieldProperties(properties: any, fieldname: any): void {
    // this.readonly = properties.readonly;
    // this.required = properties.required;
    // Update the groupFields object with the new properties
    if (this.groupFields[fieldname]) {
      this.groupFields[fieldname] = {
        ...this.groupFields[fieldname], // Keep other properties intact
        readonly: properties.readonly, // Update readonly
        required: properties.required, // Update required
      };
    }
    const eventData = { properties, fieldname };

    this.fieldPropertiesChanged.emit(eventData);
    console.log("properties", properties);
    console.log("eventData", eventData);
  }

  updateGroupAttributes(attributes: any, fieldname: any): void {
    this.hidden = attributes.hidden;
    this.islink = attributes.islink;
    this.headerfields = attributes.headerfields;
    this.hiddenonnew =
      attributes.hiddenonnew != null ? attributes.hiddenonnew : false;
    this.hiddenonedit =
      attributes.hiddenonedit != null ? attributes.hiddenonedit : false;
    this.sequence = attributes.sequence;
    this.linkfield = attributes.linkfield;
    this.linkrelativeurl = attributes.linkrelativeurl;
    this.object = attributes.object;
    this.recordtypeexist = attributes.recordtypeexist;
    this.lockedonedit = attributes.lockedonedit;
    this.lockedonnew = attributes.lockedonnew;
    // this.autofillsource = attributes.autofillsource;

    const eventData = { attributes, fieldname };

    this.groupFieldAttributesChanged.emit(eventData);
    console.log("updateGroupAttributes", attributes);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  onFieldDrop(event: DragEvent) {
    event.preventDefault();
    const data = event.dataTransfer.getData("application/json");

    if (data.length > 0) {
      const field = JSON.parse(data);
      console.log("Field:", field);

      if (field.hasOwnProperty("fieldtype")) {
        this.droppedDataFieldList.push(field);

        this.droppedDataEvent.emit({ sectionId: this.sectionId, field: field });

        console.log("Dropped data:", this.droppedDataFieldList);
        console.log("data:", field);
      } else {
        this.showWarning("Not a Field, Drop not Accepted");
        console.log(" Drop not accepted.");
      }
    }
  }

  onFieldDropchange(event: DragEvent, newIndex: number) {
    event.preventDefault();

    console.log("Current index", this.draggedIndex);
    console.log("Dropped index", newIndex);
    if (this.draggedIndex !== null && this.draggedIndex !== newIndex) {
      // Swap the positions of the dragged item and the dropped item
      const tempField = this.droppedDataFieldList[this.draggedIndex];
      this.droppedDataFieldList[this.draggedIndex] =
        this.droppedDataFieldList[newIndex];
      this.droppedDataFieldList[newIndex] = tempField;

      this.droppedDataFieldList.forEach((item, index) => {
        item.index = index;
      });

      console.log("Dropped data reordered:", this.droppedDataFieldList);
    }

    //Reset index
    this.draggedIndex = null;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragStart(event: DragEvent, index: number) {
    this.draggedIndex = index;

    console.log(index);
  }

  getColumnSize(index: number): number {
    return index % 2 === 0 ? 6 : 12;
  }

  deleteSection(index: number): void {
    this.sectionDeleted.emit(index);
  }
}
